module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10208.014cdaa5.jpg";